<template>
  <div id="app">
    <div class="layout">
      <!-- 左侧边栏 -->
      <div class="layout-left">
        <div class="sidebar-header">
          <div class="brand">
            <div class="brand-icon">
              <i class="el-icon-chat-dot-round"></i>
            </div>
            <span>智能对话助手</span>
          </div>
          <button class="new-chat-btn">
            <i class="el-icon-plus icon"></i>
            开启新对话
          </button>
        </div>

        <div class="chat-history">
          <div class="chat-item active">
            <i class="el-icon-chat-line-round"></i>
            <span>文字输出完成逻辑</span>
          </div>
          <div class="chat-item">
            <i class="el-icon-chat-line-round"></i>
            <span>CSS布局优化方案</span>
          </div>
          <div class="chat-item">
            <i class="el-icon-chat-line-round"></i>
            <span>Vue组件设计</span>
          </div>
          <div class="chat-item">
            <i class="el-icon-chat-line-round"></i>
            <span>响应式设计技巧</span>
          </div>
          <div class="chat-item">
            <i class="el-icon-chat-line-round"></i>
            <span>JavaScript最佳实践</span>
          </div>
        </div>

        <div class="sidebar-footer">
          <p>© 2023 智能对话助手 v2.0</p>
        </div>
      </div>

      <!-- 右侧主内容区 -->
      <div class="layout-right">
        <div class="top-bar">
          <div class="top-bar-title">文字输出完成逻辑</div>
        </div>

        <div class="layout-right-content">

          <div class="welcome-message" v-if="messages.length === 0">
            <div class="welcome-title">欢迎使用智能对话助手</div>
            <div class="welcome-text">
              我可以帮助您解决各种技术问题，提供编程指导，优化代码逻辑，并解释复杂的技术概念。请随时提问！
            </div>

            <div class="features">
              <div class="feature-card">
                <div class="feature-icon">
                  <i class="el-icon-cpu"></i>
                </div>
                <div class="feature-title">智能解答</div>
                <div class="feature-desc">提供准确的技术解决方案和代码示例，帮助您快速解决问题。</div>
              </div>

              <div class="feature-card">
                <div class="feature-icon">
                  <i class="el-icon-magic-stick"></i>
                </div>
                <div class="feature-title">代码优化</div>
                <div class="feature-desc">分析您的代码并提供优化建议，提高性能和可读性。</div>
              </div>

              <div class="feature-card">
                <div class="feature-icon">
                  <i class="el-icon-collection"></i>
                </div>
                <div class="feature-title">知识丰富</div>
                <div class="feature-desc">涵盖多种编程语言、框架和技术领域的最新知识。</div>
              </div>
            </div>
          </div>

          <div class="chat-container" v-else>
            <div class="message message-user">
              <div class="message-header">
                <div class="message-avatar user-avatar">你</div>
              </div>
              <div>请问如何实现文字输出的完成逻辑？</div>
            </div>

            <div class="message message-assistant">
              <div class="message-header">
                <div class="message-avatar assistant-avatar">AI</div>
              </div>
              <div>实现文字输出的完成逻辑通常有几种方法：</div>
            </div>

            <div class="message message-assistant">
              <div class="message-header">
                <div class="message-avatar assistant-avatar">AI</div>
              </div>
              <div v-dompurify-html="text">

              </div>
            </div>
            <div class="message message-assistant">
              <div class="message-header">
                <div class="message-avatar assistant-avatar">AI</div>
              </div>
              <div>
                1. 逐字输出：使用定时器逐个添加字符，模拟打字效果<br>
                2. 分段输出：将内容分成段落，逐段显示<br>
                3. 滚动定位：确保新内容出现时自动滚动到可视区域<br>
                4. 完成回调：在所有内容输出完成后触发回调函数
              </div>
            </div>
            <div class="message message-assistant">
              <div class="message-header">
                <div class="message-avatar assistant-avatar">AI</div>
              </div>
              <div>
                1. 逐字输出：使用定时器逐个添加字符，模拟打字效果<br>
                2. 分段输出：将内容分成段落，逐段显示<br>
                3. 滚动定位：确保新内容出现时自动滚动到可视区域<br>
                4. 完成回调：在所有内容输出完成后触发回调函数
              </div>
            </div>
            <div class="message message-assistant">
              <div class="message-header">
                <div class="message-avatar assistant-avatar">AI</div>
              </div>
              <div>
                1. 逐字输出：使用定时器逐个添加字符，模拟打字效果<br>
                2. 分段输出：将内容分成段落，逐段显示<br>
                3. 滚动定位：确保新内容出现时自动滚动到可视区域<br>
                4. 完成回调：在所有内容输出完成后触发回调函数
              </div>
            </div>
            <div class="typing-indicator" v-if="isTyping">
              <div class="typing-dot"></div>
              <div class="typing-dot"></div>
              <div class="typing-dot"></div>
              <span>正在输入...</span>
            </div>
          </div>

          <div class="input-content">
            <div class="layout-right-content-input">
              <div class="input-container">
                <div class="input-box">
                  <el-input
                      class="input-box-input"
                      type="textarea"
                      :autosize="{ minRows: 2, maxRows: 5}"
                      placeholder="请输入您的问题..."
                      v-model="textarea"
                  ></el-input>
                </div>
              </div>
              <div class="input-actions">
                <div class="action-icons">
                  <span class="action-icon"><i class="el-icon-picture"></i></span>
                  <!--                <span class="action-icon"><i class="el-icon-files"></i></span>-->
                  <!--                <span class="action-icon"><i class="el-icon-link"></i></span>-->
                </div>
                <button class="send-btn" @click="sendMessage">
                  <i class="el-icon-position"></i>
                </button>
                <!--              <div class="hint-text">Shift + Enter 换行</div>-->
              </div>
            </div>
            <div class="layout-right-content-tip">
              内容由 AI 生成，请仔细甄别
            </div>
          </div>

        </div>
      </div>
    </div>
  </div>
</template>

<style scoped>
* {
  margin: 0;
  padding: 0;
  box-sizing: border-box;
  font-family: 'Inter', -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, Oxygen, Ubuntu, sans-serif;
}

body {
  background-color: #f5f7fa;
  color: #333;
  height: 100vh;
  overflow: hidden;
}

#app {
  height: 100%;
}

.layout {
  display: flex;
  height: 100%;
  background: #fff;
  box-shadow: 0 0 20px rgba(0, 0, 0, 0.08);
}

/* 左侧边栏样式 */
.layout-left {
  width: 260px;
  background: linear-gradient(135deg, #6a11cb 0%, #2575fc 100%);
  color: white;
  display: flex;
  flex-direction: column;
  padding: 20px 0;
  position: relative;
  z-index: 10;
  box-shadow: 3px 0 15px rgba(0, 0, 0, 0.1);
}

.sidebar-header {
  padding: 0 20px 20px;
  border-bottom: 1px solid rgba(255, 255, 255, 0.1);
  margin-bottom: 20px;
}

.brand {
  display: flex;
  align-items: center;
  gap: 12px;
  font-size: 20px;
  font-weight: 600;
  margin-bottom: 25px;
}

.brand-icon {
  width: 32px;
  height: 32px;
  background: rgba(255, 255, 255, 0.2);
  border-radius: 8px;
  display: flex;
  align-items: center;
  justify-content: center;
}

.new-chat-btn {
  background: rgba(255, 255, 255, 0.15);
  border: none;
  color: white;
  padding: 12px 20px;
  border-radius: 12px;
  font-size: 15px;
  font-weight: 500;
  cursor: pointer;
  display: flex;
  align-items: center;
  gap: 10px;
  width: 100%;
  transition: all 0.3s ease;
}

.new-chat-btn:hover {
  background: rgba(255, 255, 255, 0.25);
  transform: translateY(-2px);
}

.new-chat-btn .icon {
  font-size: 18px;
}

.chat-history {
  flex: 1;
  overflow-y: auto;
  padding: 0 10px;
}

.chat-item {
  padding: 12px 16px;
  border-radius: 10px;
  margin-bottom: 8px;
  cursor: pointer;
  display: flex;
  align-items: center;
  gap: 10px;
  transition: all 0.2s;
}

.chat-item:hover {
  background: rgba(255, 255, 255, 0.1);
}

.chat-item.active {
  background: rgba(255, 255, 255, 0.2);
}

.chat-item .icon {
  opacity: 0.7;
}

.sidebar-footer {
  padding: 20px;
  border-top: 1px solid rgba(255, 255, 255, 0.1);
  color: rgba(255, 255, 255, 0.7);
  font-size: 13px;
}

/* 右侧主内容区样式 */
.layout-right {
  flex: 1;
  display: flex;
  flex-direction: column;
  background: #f9fafb;
}

.top-bar {
  height: 50px;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 0;
  border-bottom: 1px solid #eee;
  box-shadow: 0 2px 10px rgba(0, 0, 0, 0.03);
  /* 修改后的渐变：顶部完全不透明 -> 底部高度透明 */
  background: linear-gradient(
      to bottom,
      rgba(255, 255, 255, 1) 0%,
      rgba(255, 255, 255, 0.7) 100%
  );
  z-index: 5;
}

.top-bar-title {
  font-size: 14px;
  text-align: center;
  font-weight: 500;
  color: #2c3e50;
}

.layout-right-content {
  flex: 1;
  display: flex;
  flex-direction: column;
  max-width: 900px;
  width: 100%;
  padding: 30px 20px 0;
  margin: 0 auto 150px;
  height: calc(100% - 60px);
  overflow-y: auto;
  scrollbar-width: none; /* firefox */
  -ms-overflow-style: none; /* IE 10+ */
}

.layout-right-content::-webkit-scrollbar {

  display: none; /* Chrome Safari */
}

.layout-right-content-title {
  text-align: center;
  font-size: 28px;
  font-weight: 700;
  margin-bottom: 30px;
  color: #2c3e50;
  background: linear-gradient(135deg, #6a11cb 0%, #2575fc 100%);
  -webkit-background-clip: text;
  -webkit-text-fill-color: transparent;
}

.chat-container {
  flex: 1;
  display: flex;
  flex-direction: column;
  gap: 25px;
  margin-bottom: 60px;
}

.message {
  max-width: 85%;
  padding: 18px 22px;
  border-radius: 18px;
  line-height: 1.6;
  position: relative;
  animation: fadeIn 0.3s ease;
}

@keyframes fadeIn {
  from {
    opacity: 0;
    transform: translateY(10px);
  }
  to {
    opacity: 1;
    transform: translateY(0);
  }
}

.message-user {
  align-self: flex-end;
  background: linear-gradient(135deg, #6a11cb 0%, #2575fc 100%);
  color: white;
  border-bottom-right-radius: 5px;
}

.message-assistant {
  align-self: flex-start;
  background: white;
  color: #333;
  box-shadow: 0 4px 15px rgba(0, 0, 0, 0.05);
  border-bottom-left-radius: 5px;
}

.message-header {
  display: flex;
  align-items: center;
  gap: 10px;
  margin-bottom: 8px;
  font-weight: 500;
}

.message-avatar {
  width: 28px;
  height: 28px;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  font-weight: 600;
  font-size: 14px;
}

.user-avatar {
  background: rgba(255, 255, 255, 0.3);
}

.assistant-avatar {
  background: linear-gradient(135deg, #6a11cb 0%, #2575fc 100%);
  color: white;
}

.typing-indicator {
  display: flex;
  align-items: center;
  gap: 5px;
  padding: 18px 22px;
  background: white;
  align-self: flex-start;
  box-shadow: 0 4px 15px rgba(0, 0, 0, 0.05);
  border-radius: 18px 18px 18px 5px;
}

.typing-dot {
  width: 8px;
  height: 8px;
  background: #6a11cb;
  border-radius: 50%;
  animation: typing 1.4s infinite ease-in-out;
}

.typing-dot:nth-child(1) {
  animation-delay: 0s;
}

.typing-dot:nth-child(2) {
  animation-delay: 0.2s;
}

.typing-dot:nth-child(3) {
  animation-delay: 0.4s;
}

@keyframes typing {
  0%, 60%, 100% {
    transform: translateY(0);
  }
  30% {
    transform: translateY(-5px);
  }
}


/* 输入区域样式 */
.input-content {
  position: fixed;
  bottom: 10px;
}


.layout-right-content-input {
  width: 845px;
  background: white;
  border-radius: 16px;
  padding: 15px;
  box-shadow: 0 5px 25px rgba(0, 0, 0, 0.1);
  margin-top: 20px;
  border: 1px solid #e6e9ef;
}


.layout-right-content-tip {
  margin-top: 10px;
  text-align: center;
}


.input-box {
  flex: 1;
}

.input-box-input {
  width: 100%;
}

.input-box :deep(.el-textarea__inner) {
  border: none !important;
  background: #f9fafb !important;
  border-radius: 12px !important;
  padding: 15px !important;
  font-size: 15px !important;
  box-shadow: none !important;
  resize: none !important;
  transition: all 0.3s ease !important;
}

.input-box :deep(.el-textarea__inner):focus {
  box-shadow: 0 0 0 2px rgba(106, 17, 203, 0.2) !important;
}

.send-btn {
  background: linear-gradient(135deg, #6a11cb 0%, #2575fc 100%);
  border: none;
  color: white;
  width: 35px;
  height: 35px;
  //border-radius: 12px;
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  transition: all 0.3s ease;
  align-self: flex-end;
  box-shadow: 0 4px 15px rgba(106, 17, 203, 0.3);
  border-radius: 50%;
  font-size: 19px;
}

.send-btn:hover {
  transform: translateY(-2px);
  box-shadow: 0 6px 20px rgba(106, 17, 203, 0.4);
}

.input-actions {
  display: flex;
  //justify-content: space-between;
  justify-content: flex-end;
  align-items: center;
  margin-top: 10px;
  color: #909399;
  font-size: 13px;
  padding: 0 5px;
}

.layout-tip {
  text-align: center;
}

.action-icons {
  display: flex;
  align-items: center;
  justify-content: center;
  //gap: 15px;
  margin-right: 10px;
  width: 35px;
  height: 35px;
}

.action-icon {
  cursor: pointer;
  transition: color 0.2s;
  font-size: 30px;
}

.action-icon:hover {
  color: #6a11cb;
}

.welcome-message {
  text-align: center;
  padding: 30px;
  color: #5c6b7a;
  max-width: 700px;
  margin: 0 auto;
}

.welcome-title {
  font-size: 24px;
  font-weight: 700;
  margin-bottom: 15px;
  color: #2c3e50;
}

.welcome-text {
  line-height: 1.8;
  margin-bottom: 25px;
}

.features {
  display: flex;
  gap: 20px;
  margin-top: 30px;
}

.feature-card {
  background: white;
  border-radius: 16px;
  padding: 25px;
  flex: 1;
  box-shadow: 0 5px 15px rgba(0, 0, 0, 0.05);
  transition: all 0.3s ease;
}

.feature-card:hover {
  transform: translateY(-5px);
  box-shadow: 0 8px 25px rgba(0, 0, 0, 0.1);
}

.feature-icon {
  font-size: 24px;
  color: #6a11cb;
  margin-bottom: 15px;
}

.feature-title {
  font-weight: 600;
  margin-bottom: 10px;
  color: #2c3e50;
}

.feature-desc {
  color: #5c6b7a;
  font-size: 14px;
  line-height: 1.6;
}

/* 响应式调整 */
@media (max-width: 992px) {
  .layout-left {
    width: 220px;
  }

  .features {
    flex-direction: column;
  }
}

@media (max-width: 768px) {
  .layout {
    flex-direction: column;
  }

  .layout-left {
    width: 100%;
    height: auto;
  }

  .chat-history {
    max-height: 200px;
  }
}
</style>

<script>
import {marked} from "marked";
import hljs from "highlight.js";

export default {

  name: "index",
  data() {
    return {
      text: "n嗯，用户让我生成一个表格，但没有具体说明内容。首先，我需要确定他们想要什么样的表格。可能他们只是想测试我的能力，或者他们有一个特定的用途，比如数据展示、比较信息，或者教学材料。\\n\\n接下来，我应该考虑常见的表格类型。比如，产品比较表、课程时间表、营养成分表等等。用户可能希望我提供一个通用的例子，或者他们可能有更具体的需求，但没说清楚。这时候，我需要做一个假设，选择一个常见且结构清晰的例子，这样用户即使没有详细说明也能得到有用的信息。\\n\\n然后，我得确保表格的格式正确。使用Markdown来创建表格比较合适，因为它简洁易读。标题行要明确，列名要清晰，比如“项目”、“描述”、“示例”这样的结构，方便用户理解每个部分的内容。\\n\\n还要注意表格的美观和可读性。对齐方式、边框是否需要，这些细节可能会影响用户体验。不过用户可能只需要基本的结构，所以保持简单明了比较好。\\n\\n另外，用户可能希望表格有实际应用价值，比如用于报告、演示文稿或个人笔记。因此，选择一个通用的例子，如不同编程语言的特点，可以展示表格的多种用途，同时提供有用的信息。\\n\\n最后，检查是否有遗漏的部分，比如是否需要更多的列或行，或者是否需要添加注释。确保示例中的内容准确且易于理解，避免错误信息。完成后，再通读一遍，确认格式正确，没有语法错误，这样用户可以直接复制使用。\\n\\n是一个简单的表格示例（使用 Markdown 格式）：\\n\\n```markdown\\n| 项目       | 描述                     | 示例           |\\n|------------|--------------------------|----------------|\\n| **姓名**   | 用户的全名               | 张三           |\\n| **年龄**   | 当前年龄                 | 25             |\\n| **职业**   | 主要工作或学习领域       | 软件工程师     |\\n| **城市**   | 居住地                   | 北京           |\\n| **技能**   | 熟练掌握的技能或工具     | Python, SQL    |\\n```\\n\\n如果你有具体的表格需求（例如：数据对比、课程表、产品规格等），请提供更多细节，我可以帮你定制更符合要求的表格！ 😊",
      textarea: '',
      messages: [
        {content: '请问如何实现文字输出的完成逻辑？', type: 'user'}
      ],
      isTyping: true
    }
  },
  methods: {
    async sendMessage() {
      try {
        const response = await fetch('https://usage.zhongangongjiang.com/v1/chat-messages', {
          method: "POST",
          headers: {
            Authorization: "Bearer app-dlwtsefq30H0M24or2qPSpZf",
            "Content-Type": "application/json"
          },
          body: JSON.stringify({
            "inputs": {},
            "query": "What are the specs of the iPhone 13 Pro Max?",
            "response_mode": "streaming",
            "conversation_id": "",
            "user": "abc-123",
            "files": []
          })
        });

        if (!response.ok) {
          throw new Error(`HTTP error! status: ${response.status}`);
        }

        // 处理流式响应
        const reader = response.body.getReader();
        const decoder = new TextDecoder();
        let buffer = '';
        const objects = [];

        while (true) {
          const { value, done } = await reader.read();
          if (done) break;

          // 解码并处理数据块
          buffer += decoder.decode(value, { stream: true });

          // 按行分割处理
          const lines = buffer.split('\n');
          buffer = lines.pop() || ''; // 保存未完成的行

          for (const line of lines) {
            const trimmedLine = line.trim();
            if (!trimmedLine) continue; // 跳过空行

            // 检查是否是 SSE 数据行
            if (trimmedLine.startsWith('data:')) {
              try {
                // 移除 "data: " 前缀
                const jsonStr = trimmedLine.replace(/^data:\s*/, '');

                // 解析 JSON 对象
                const obj = JSON.parse(jsonStr);
                objects.push(obj);

                // 实时打印解析后的对象
                console.log("Received SSE object:", obj);
              } catch (err) {
                console.warn("Failed to parse SSE JSON:", trimmedLine, err);
              }
            } else {
              // 处理其他类型的事件（可选）
              console.log("Non-data event:", trimmedLine);
            }
          }
        }

        // 处理缓冲区中剩余的数据
        if (buffer.trim() !== '') {
          // 这里可以添加与上面相同的 SSE 处理逻辑
          console.warn("Remaining buffer content:", buffer);
        }

        // 打印完整结果集
        console.log("All response objects:", objects);

        // 返回解析后的对象数组
        return objects;
      } catch (err) {
        console.error("Error:", err);
        throw err;
      }
    },
    markdownContent(content) {
      const renderer = new marked.Renderer();
      renderer.code = (code, lang) => {
        const id = `code-${Date.now()}`;
        const highlightedCode =
            lang && hljs.getLanguage(lang)
                ? hljs.highlight(lang, code).value
                : hljs.highlightAuto(code).value;
        return `<div class="code-copy" style="width: 100%;height: 25px; margin-top: 20px;background-color: #343541;border-top-right-radius: 5px;border-top-left-radius: 5px;">
      <div style="width: 95%;height: 25px;margin: 0 auto;">
           <div style="width: 50%;height: 25px;float: left;color: #d9d9e3;font-size: 10px;line-height: 25px;">${lang}</div>
           <div style="width: 50%;height: 25px;float: left;color: #d9d9e3;text-align: right;font-size: 10px;line-height: 25px;">
           <svg t="1688534062391" class="icon" style="width: 1.5em;height: 1.5em;display: inline-block;margin-bottom: -3px;" viewBox="0 0 1024 1024" version="1.1" xmlns="http://www.w3.org/2000/svg" p-id="2322" width="200" height="200"><path d="M857.373005 65.290005 469.604424 65.290005c-34.211173 0-62.044078 27.832905-62.044078 62.043055l0 10.340509-63.076594 0c-25.993001 0-48.228421 16.346293-57.001225 39.293935L166.626995 176.967504c-34.21015 0-62.043055 27.832905-62.043055 62.043055l0 657.655358c0 34.21015 27.832905 62.043055 62.043055 62.043055l550.115086 0c34.21015 0 62.043055-27.832905 62.043055-62.043055l0-49.634444 78.587869 0c34.21015 0 62.043055-27.832905 62.043055-62.043055L919.41606 127.33306C919.41606 93.122911 891.583155 65.290005 857.373005 65.290005zM344.483752 179.035606l194.402595 0c10.833743 0 19.646456 8.813736 19.646456 19.646456 0 10.833743-8.813736 19.646456-19.646456 19.646456L344.483752 218.328517c-10.833743 0-19.646456-8.813736-19.646456-19.646456C324.836273 187.849342 333.650009 179.035606 344.483752 179.035606zM737.423099 896.665917c0 11.402701-9.278317 20.681018-20.681018 20.681018L166.626995 917.346935c-11.403724 0-20.681018-9.278317-20.681018-20.681018L145.945977 239.010559c0-11.402701 9.277294-20.681018 20.681018-20.681018l120.111588 0c8.197706 24.02723 30.977525 41.362037 57.744145 41.362037l194.402595 0c26.767644 0 49.54644-17.334807 57.744145-41.362037l120.111588 0c11.402701 0 20.681018 9.278317 20.681018 20.681018L737.422076 896.665917zM878.054023 784.988418c0 11.402701-9.278317 20.681018-20.681018 20.681018l-78.587869 0L778.785136 239.010559c0-34.21015-27.832905-62.043055-62.043055-62.043055L595.886549 176.967504c-8.771781-22.947641-31.007201-39.293935-57.001225-39.293935l-89.963964 0L448.921359 127.33306c0-11.403724 9.278317-20.681018 20.683065-20.681018l387.768581 0c11.402701 0 20.681018 9.277294 20.681018 20.681018L878.054023 784.988418z" fill="#ffffff" p-id="2323"></path><path d="M620.597347 334.252737 260.748652 334.252737c-11.422144 0-20.681018 9.259898-20.681018 20.681018s9.258874 20.681018 20.681018 20.681018l359.849718 0c11.42112 0 20.681018-9.259898 20.681018-20.681018S632.018467 334.252737 620.597347 334.252737z" fill="#ffffff" p-id="2324"></path><path d="M620.597347 454.201619 260.748652 454.201619c-11.422144 0-20.681018 9.259898-20.681018 20.681018 0 11.42112 9.258874 20.681018 20.681018 20.681018l359.849718 0c11.42112 0 20.681018-9.259898 20.681018-20.681018C641.278365 463.46254 632.018467 454.201619 620.597347 454.201619z" fill="#ffffff" p-id="2325"></path><path d="M440.673511 574.151525 260.748652 574.151525c-11.422144 0-20.681018 9.259898-20.681018 20.681018 0 11.42112 9.258874 20.681018 20.681018 20.681018l179.924859 0c11.42112 0 20.681018-9.259898 20.681018-20.681018C461.35453 583.411423 452.093609 574.151525 440.673511 574.151525z" fill="#ffffff" p-id="2326"></path></svg>
                <span style="cursor: pointer;" class="copy-button" data-clipboard-target="#${id}">
                复制</span>
           </div>
      </div>
    </div>
    <pre><code class="hljs ${lang}" id="${id}">${highlightedCode}</code></pre>`;
      };
      marked.setOptions({renderer});
      return marked(content);
    },
  },
  mounted() {
    console.log("mounted 阶段开始", this.text); // 调试点1
    this.text = this.markdownContent(this.text);
    console.log("渲染后的HTML:", this.text); // 调试点2
    // 模拟AI正在输入
    setTimeout(() => {
      this.isTyping = false;
      this.messages.push(
          {content: '实现文字输出的完成逻辑通常有几种方法：', type: 'assistant'},
          {
            content: `1. 逐字输出：使用定时器逐个添加字符，模拟打字效果
2. 分段输出：将内容分成段落，逐段显示
3. 滚动定位：确保新内容出现时自动滚动到可视区域
4. 完成回调：在所有内容输出完成后触发回调函数`,
            type: 'assistant'
          },
          {
            content: `1. 逐字输出：使用定时器逐个添加字符，模拟打字效果
2. 分段输出：将内容分成段落，逐段显示
3. 滚动定位：确保新内容出现时自动滚动到可视区域
4. 完成回调：在所有内容输出完成后触发回调函数`,
            type: 'assistant'
          },
          {
            content: `1. 逐字输出：使用定时器逐个添加字符，模拟打字效果
2. 分段输出：将内容分成段落，逐段显示
3. 滚动定位：确保新内容出现时自动滚动到可视区域
4. 完成回调：在所有内容输出完成后触发回调函数`,
            type: 'assistant'
          }, {
            content: `1. 逐字输出：使用定时器逐个添加字符，模拟打字效果
2. 分段输出：将内容分成段落，逐段显示
3. 滚动定位：确保新内容出现时自动滚动到可视区域
4. 完成回调：在所有内容输出完成后触发回调函数`,
            type: 'assistant'
          }
      );
    }, 2000);
  }
}
</script>
